import { useEffect, useMemo, useState } from 'react';

export const useIsDesktop = (breakpoint: number) => {
  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= breakpoint);

  useEffect(() => {
    const mediaQueryList = window.matchMedia(`(min-width: ${breakpoint}px)`);

    const handleMediaChange = (event: MediaQueryListEvent) => {
      setIsDesktop(event.matches);
    };

    mediaQueryList.addEventListener('change', handleMediaChange);

    // Set initial value based on current window size
    setIsDesktop(mediaQueryList.matches);

    return () => {
      mediaQueryList.removeEventListener('change', handleMediaChange);
    };
  }, [breakpoint]);

  return useMemo(() => isDesktop, [isDesktop]);
};
